/**
 * DevExtreme (esm/__internal/grids/tree_list/column_headers/m_column_headers.js)
 * Version: 22.2.12
 * Build date: Mon Apr 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    columnHeadersModule
} from "../../../grids/grid_core/column_headers/m_column_headers";
import treeListCore from "../m_core";
var ColumnHeadersView = columnHeadersModule.views.columnHeadersView.inherit({
    setTableRole($tableElement) {
        this.setAria("role", "treegrid", $tableElement)
    }
});
treeListCore.registerModule("columnHeaders", {
    defaultOptions: columnHeadersModule.defaultOptions,
    views: {
        columnHeadersView: ColumnHeadersView
    }
});
